// CN
import { BaiduMap, Marker as CMarker } from "react-baidu-maps";

// Not CN
import {
  GoogleMap,
  withScriptjs,
  withGoogleMap,
  Marker
} from "react-google-maps";

import React from "react";
import preLoading from "Assets/Images/preLoading.png";
import top from "Assets/Images/top.png";
import contentReservation from "Assets/Images/contentReservation.png";
import contentIntroduction3 from "Assets/Images/contentIntroduction3.png";
import contentDoc from "Assets/Docs/Foreigner_Reservation_Layout.docx";

import contentDocUS from "Assets/Docs/Reservation_Layout_US.docx";
import contentDocJP from "Assets/Docs/Reservation_Layout_JP.docx";
import contentDocRS from "Assets/Docs/Reservation_Layout_RS.docx";

const isCN = false;
const WrappedMap = withScriptjs(withGoogleMap(Map));
function Map() {
  return (
    <GoogleMap defaultZoom={15} defaultCenter={defaultCenter}>
      <Marker position={defaultCenter} />
    </GoogleMap>
  );
}

const defaultCenter = { lng: 127.01444, lat: 37.491579 };
const defaultZoom = 16;
const enableDragging = true;

export default class extends React.Component {
  state = {
    loading: true
  };

  componentDidMount() {
    this.setState({ loading: false });
  }

  _goToTop() {
    window.scrollTo(0, 0);
  }

  render() {
    const { loading } = this.state;
    return (
      <div className="contents reservation">
        <img
          src={loading ? preLoading : contentReservation}
          alt="preLoading"
          className="contentMain"
        />
        <div className="SNSLink">
          <div id="link1" />
          <div id="link2" href="" />
          <a id="link3" href="http://pf.kakao.com/_dxfrsT" target="_blank" />
          <div id="link4" />
          <div id="link5" />
          <div id="link6" />
        </div>
        <div className="docLink">
          <a id="docLink1" href={contentDoc} />
          <a id="docLink2" href={contentDocUS} />
          <a id="docLink3" href={contentDocJP} />
          <a id="docLink4" href={contentDocRS} />
        </div>
        {isCN ? (
          <div className="maps">
            <BaiduMap
              mapUrl={`http://api.map.baidu.com/api?v=2.0&ak=pdWpMi9dG6TvzAXOYC7E40KP13hnDFEj`}
              loadingElement={<div>Loading.....</div>}
              mapContainer={<div style={{ height: "100%" }} />}
              defaultCenter={defaultCenter}
              defaultZoom={defaultZoom}
              enableScrollWheelZoom
              enableDragging={enableDragging}
            >
              <CMarker position={{ lng: 127.014446, lat: 37.491576 }} />
            </BaiduMap>
          </div>
        ) : (
          <div className="maps">
            <WrappedMap
              googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyDVeXGJqVyFbENKDy_IecRtNUqqbk7-224`}
              loadingElement={
                <div
                  style={{ height: "100%", width: "42vw", margin: "auto" }}
                />
              }
              containerElement={
                <div
                  style={{ height: "100%", width: "42vw", margin: "auto" }}
                />
              }
              mapElement={<div style={{ height: "100%" }} />}
            />
          </div>
        )}
        <img
          src={contentIntroduction3}
          alt="contentIntroduction3"
          className="contentMain"
        />
        <img
          src={top}
          alt="top"
          className={loading ? "invisible contentTop" : "contentTop"}
          onClick={this._goToTop}
        />
      </div>
    );
  }
}
